

import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const WTPPreventiveSecurityPageExport = (props) => {
    const { ExcelData, name, ToDate, FromDate, WardName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-WTPPreventiveSecurityPageExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-WTPPreventiveSecurityPageExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <tr>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }}>From Date: {moment(FromDate).format('DD-MM-YYYY')}</td>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }}>To Date: {moment(ToDate).format('DD-MM-YYYY')}</td>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }}>Ward Name: {WardName}</td>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th>Sr.No.</th>
                        <th>Reading Date</th>
                        <th>Pumping Station</th>
                        <th>{name == "Security" ? "Security Type" : "House Keeping Type"}</th>
                        <th>Status</th>
                        <th>Photo</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.pumpingStation ? item.pumpingStation : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{name == "Security" ? item.securityType : item.houseKeepingType}</td>
                                    <td style={{ textAlign: "center" }}>{item.indicatorName ? item.indicatorName : '-'}</td>
                                    <td style={{ textAlign: "center" }}>
                                        {
                                            (item.photo == null) ?
                                                <span>-</span>
                                                :
                                                <>
                                                    <a href={item.photo} target="_blank" rel="noopener noreferrer">View</a>
                                                </>
                                        }
                                    </td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}